
export const SERVER_URL = (
  process.env.REACT_APP_LIVEKIT_URL || 'ws://localhost:7880'
).replace(/\/$/, '')
export const BACKEND = (
  process.env.REACT_APP_BASE_URL || 'http://localhost:3004'
).replace(/\/$/, ''); 

/**
 * Socket.IO treats pathname as namespace, not Engine.IO path.
 * So io('https://app.mypeegu.com/api') hits /socket.io (SPA) instead of /api/socket.io.
 * Strip trailing /api and set path when BASE_URL includes the nginx API prefix.
 *
 * Auth (required when backend SOCKET_AUTH_REQUIRED=true):
 *  - MyPeegu staff:  { token: user.authToken }
 *  - School portal:  { vcSchoolToken: session.token }
 */
export function getSocketIoConfig(extra = {}) {
  const base = BACKEND.replace(/\/$/, '')
  const viaApiPrefix = /\/api$/i.test(base)
  const forcePolling = String(process.env.REACT_APP_SOCKET_IO_FORCE_POLLING || '')
    .toLowerCase() === 'true'
  const forceWebsocket = String(process.env.REACT_APP_SOCKET_IO_FORCE_WEBSOCKET || '')
    .toLowerCase() === 'true'

  let transports = ['polling', 'websocket']
  let upgrade = true
  if (forcePolling) {
    transports = ['polling']
    upgrade = false
  } else if (forceWebsocket) {
    transports = ['websocket', 'polling']
    upgrade = true
  }

  const { auth, ...restExtra } = extra || {}

  return {
    url: viaApiPrefix ? base.replace(/\/api$/i, '') : base,
    options: {
      path: viaApiPrefix ? '/api/socket.io' : '/socket.io',
      transports,
      upgrade,
      rememberUpgrade: !forcePolling,
      reconnection: true,
      reconnectionAttempts: 8,
      reconnectionDelay: 3000,
      reconnectionDelayMax: 20000,
      timeout: 20000,
      ...(auth ? { auth } : {}),
      ...restExtra,
    },
  }
}

/** Staff Socket.IO — MyPeegu auth-token on handshake. */
export function getStaffSocketIoConfig(authToken, extra = {}) {
  if (!authToken) return getSocketIoConfig(extra)
  return getSocketIoConfig({ ...extra, auth: { token: authToken } })
}

/** School portal Socket.IO — vc-school-token on handshake. */
export function getSchoolSocketIoConfig(vcSchoolToken, extra = {}) {
  if (!vcSchoolToken) return getSocketIoConfig(extra)
  return getSocketIoConfig({ ...extra, auth: { vcSchoolToken } })
}

export const ROUTES = { HOME: '/', KIOSK: '/kiosk', COUNSELLOR: '/counsellor' };

// MyPeegu brand palette
export const C = {
  purple:      '#7B2FBE',
  purpleDeep:  '#5A189A',
  purpleLight: '#9D4EDD',
  purplePale:  '#F0E6FF',
  heroGrad:    'linear-gradient(135deg, #9D4EDD 0%, #7B2FBE 50%, #5A189A 100%)',
  purpleGrad:  'linear-gradient(135deg, #7B2FBE, #5A189A)',
  teal:        '#1ABC9C',
  tealDark:    '#16A085',
  tealGrad:    'linear-gradient(135deg, #1ABC9C, #27AE60)',
  tealPale:    '#E8FBF6',
  blue:        '#4361EE',
  bluePale:    '#EAF0FF',
  blueGrad:    'linear-gradient(135deg, #4361EE, #4CC9F0)',
  orange:      '#F77F00',
  orangePale:  '#FFF4E6',
  orangeGrad:  'linear-gradient(135deg, #F77F00, #FCBF49)',
  bg:          '#F4F6FB',
  white:       '#FFFFFF',
  dark:        '#1A1A2E',
  mid:         '#4A4A68',
  muted:       '#8A8AA0',
  border:      '#E8EAF6',
  danger:      '#E63946',
  dangerGrad:  'linear-gradient(135deg, #E63946, #C1121F)',
};
